/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { JobOccurrenceFilterOptionsDto } from './JobOccurrenceFilterOptionsDto';
import {
    JobOccurrenceFilterOptionsDtoFromJSON,
    JobOccurrenceFilterOptionsDtoFromJSONTyped,
    JobOccurrenceFilterOptionsDtoToJSON,
} from './JobOccurrenceFilterOptionsDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto
 */
export interface ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<JobOccurrenceFilterOptionsDto>}
     * @memberof ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto
     */
    value?: Array<JobOccurrenceFilterOptionsDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto
     */
    $type?: ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedJobExecutionDtoJobOccurrenceFilterOptionsDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.JobOccurrenceFilterOptionsDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoTypeEnum = typeof ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto interface.
 */
export function instanceOfODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto(value?: unknown): value is ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoFromJSON(json: any): ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto {
    return ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(JobOccurrenceFilterOptionsDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoToJSON(value?: ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(JobOccurrenceFilterOptionsDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

